import { all, call, put, takeLatest } from 'redux-saga/effects';

import { request } from '@app/services';
import {
  getDesignations,
  getDesignationsFailed,
  getDesignationsSuccess,
  deleteDesignation,
  deleteDesignationSuccess,
  deleteDesignationFailed,
  addDesignation,
  addDesignationSuccess,
  addDesignationFailed,
} from './slice';
import * as endpoints from './endpoints';

// ----------------------------------------
function* getDesignationSaga(action: ReturnType<typeof getDesignations>): any {
  try {
    const result = yield call(request.get, endpoints.getDesignations);
    yield put(getDesignationsSuccess(result.data));
  } catch (err) {
    yield put(getDesignationsFailed(err));
  }
}
// ----------------------------------------
function* deleteDesignationSagas(action: ReturnType<typeof deleteDesignation>): any {
  try {
    const { id } = action.payload;

    const result = yield call(request.delete, endpoints.getDesignations, {
      data: {
        id,
      },
    });
    yield put(deleteDesignationSuccess(result.data));
  } catch (err) {
    yield put(deleteDesignationFailed(err));
  }
}
// ----------------------------------------
function* addDesignationSagas(action: ReturnType<typeof addDesignation>): any {
  try {
    const { name, desc, id } = action.payload;
    const result = yield call(request.post, endpoints.getDesignations, {
      id,
      name,
      desc,
    });
    yield put(addDesignationSuccess(result.data));
  } catch (err) {
    yield put(addDesignationFailed(err));
  }
}

function* designationSagas() {
  yield all([
    takeLatest(
      [getDesignations, addDesignationSuccess, deleteDesignationSuccess],
      getDesignationSaga
    ),
    takeLatest(deleteDesignation, deleteDesignationSagas),
    takeLatest(addDesignation, addDesignationSagas),
  ]);
}

export { designationSagas };
